import { Auth } from '@opoint/authjs-react'
import { ConfigurationTeam, Task, Assignment } from './types';
import { Dayjs } from 'dayjs';

export const getTeams = async (
    auth: Auth | undefined,
    date: Dayjs,
): Promise<ConfigurationTeam[]> => {
    const result = await fetch(
        import.meta.env.VITE_RUNTIME_API_URL
        + "/sites/configuration/teams/?date="
        + encodeURIComponent(date.format('YYYY-MM-DD')), {
        headers: {
            Authorization: 'JWT ' + (await auth?.getTokenString()),
        },
    });
    return result.json();
};

export const createAssignment = async (
    auth: Auth | undefined,
    assignment: Assignment,
): Promise<number|null> => {
    const result = await fetch(import.meta.env.VITE_RUNTIME_API_URL + "/sites/configuration/teams/assignments/", {
        method: 'POST',
        headers: {
            'Authorization': 'JWT ' + (await auth?.getTokenString()),
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(assignment),
    });
    const data = await result.json();
    if (result.ok) {
        return data.id;
    } else {
        return null;
    }
};

export const getAssignments = async (auth: Auth | undefined, modulo: number, date: Dayjs): Promise<Assignment[]> => {
    const result = await fetch(
        import.meta.env.VITE_RUNTIME_API_URL +
        "/sites/configuration/teams/assignments/"
        + "?modulo=" + encodeURIComponent(modulo)
        + "&date=" + encodeURIComponent(date.format('YYYY-MM-DD')),
        {
            headers: {
                Authorization: 'JWT ' + (await auth?.getTokenString()),
            },
        },
    );
    return result.json();
};

export const deleteAssignment = async (auth: Auth | undefined, id: number): Promise<boolean> => {
    const result = await fetch(import.meta.env.VITE_RUNTIME_API_URL + "/sites/configuration/teams/assignments/" + id + "/", {
        method: 'DELETE',
        headers: {
            'Authorization': 'JWT ' + (await auth?.getTokenString()),
        },
    });
    return result.ok;
};

export const getTasks = async (auth: Auth | undefined): Promise<Task[]> => {
    const result = await fetch(import.meta.env.VITE_RUNTIME_API_URL + "/sites/configuration/tasks/", {
        headers: {
            Authorization: 'JWT ' + (await auth?.getTokenString()),
        },
    });
    return result.json();
};


export const updateAssignment = async (
    auth: Auth | undefined,
    id_assignment: number,
    updatedValues: any
): Promise<boolean> => {
    const result = await fetch(import.meta.env.VITE_RUNTIME_API_URL + "/sites/configuration/teams/assignments/" + id_assignment + "/", {
        method: 'PATCH',
        headers: {
            'Authorization': 'JWT ' + (await auth?.getTokenString()),
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ...updatedValues,
        }),
    });
    return result.ok;
};

export const createOrUpdateTask = async (auth: Auth | undefined, task: Task): Promise<number | undefined> => {
    const result = await fetch(import.meta.env.VITE_RUNTIME_API_URL + "/sites/configuration/tasks/", {
        method: 'POST',
        headers: {
            'Authorization': 'JWT ' + (await auth?.getTokenString()),
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(task),
    });
    let id_task;
    if (result.status === 201) {
        await result.json().then(
            (data) => {
                id_task = data.id_task;
            }
        );
    }
    return id_task;
};

export const deleteTask = async (auth: Auth | undefined, id_task: number): Promise<boolean> => {
    const result = await fetch(import.meta.env.VITE_RUNTIME_API_URL + "/sites/configuration/tasks/" + id_task + "/", {
        method: 'DELETE',
        headers: {
            'Authorization': 'JWT ' + (await auth?.getTokenString()),
        },
    });
    return result.ok;
}